@if (isModal) {
	<div class="auth-card">
		@if (isRegister === 5) {
			<ng-container *ngTemplateOutlet="decorativePanel"></ng-container>
			<ng-container *ngTemplateOutlet="formPanel"></ng-container>
		} @else {
			<ng-container *ngTemplateOutlet="formPanel"></ng-container>
			<ng-container *ngTemplateOutlet="decorativePanel"></ng-container>
		}
	</div>

	<div class="auth-mobile auth-mobile--modal">
		<ng-container *ngTemplateOutlet="mobileLayout"></ng-container>
	</div>
} @else {
	<div class="auth-page">
		<div class="auth-card">
			@if (isRegister === 5) {
				<ng-container *ngTemplateOutlet="decorativePanel"></ng-container>
				<ng-container *ngTemplateOutlet="formPanel"></ng-container>
			} @else {
				<ng-container *ngTemplateOutlet="formPanel"></ng-container>
				<ng-container *ngTemplateOutlet="decorativePanel"></ng-container>
			}
		</div>
	</div>

	<div class="auth-mobile">
		<ng-container *ngTemplateOutlet="mobileLayout"></ng-container>
	</div>
}


<!-- ==================== REUSABLE TEMPLATES ==================== -->

<!-- MOBILE LAYOUT (shared between modal and standalone) -->
<ng-template #mobileLayout>
	<header class="auth-mobile__header">
		@if (brandLogo) {
			<img [src]="brandLogo" [alt]="'common.a11y.logo' | transloco" class="auth-mobile__logo" />
		}
		<h1 class="auth-mobile__brand">{{ brandName }}</h1>
		<p class="auth-mobile__subtitle">{{ 'auth.mobileHeader.subtitle' | transloco }}</p>
	</header>

	<div class="auth-mobile__body">
		<ng-container *ngTemplateOutlet="formContent"></ng-container>
	</div>

	<footer class="auth-mobile__footer decorative-gradient">
		@if (isRegister === 1) {
			<span class="auth-mobile__footer-label">{{ 'auth.decorative.login.text' | transloco }}</span>
			<app-button
				class="decorative-cta-button"
				[label]="decorativeContent.cta"
				variant="secondary"
				size="medium"
				(onClick)="decorativeContent.ctaAction()">
			</app-button>
		}
		@if (isRegister === 5) {
			<span class="auth-mobile__footer-label">{{ 'auth.decorative.signup.text' | transloco }}</span>
			<app-button
				class="decorative-cta-button"
				[label]="decorativeContent.cta"
				variant="secondary"
				size="medium"
				(onClick)="decorativeContent.ctaAction()">
			</app-button>
		}
		@if (isRegister === 2) {
			<span class="auth-mobile__footer-label">{{ 'auth.decorative.reset.text' | transloco }}</span>
			<app-button
				class="decorative-cta-button"
				[label]="'auth.decorative.reset.cta' | transloco"
				variant="secondary"
				size="medium"
				(onClick)="navigateToLogin()">
			</app-button>
		}
	</footer>
</ng-template>

<!-- FORM PANEL (desktop) -->
<ng-template #formPanel>
	<div class="auth-form-panel">
		@if (!showSuccessState) {
			<h2 class="auth-form-panel__title">
				@if (isRegister === 1) { {{ 'auth.login.title' | transloco }} }
				@else if (isRegister === 2) { {{ 'auth.resetPassword.title' | transloco }} }
				@else if (isRegister === 3) { {{ 'auth.resetPasswordConfirm.title' | transloco }} }
				@else if (isRegister === 4) { {{ 'auth.login.mfa.title' | transloco }} }
				@else if (isRegister === 5) { {{ 'auth.createAccount.title' | transloco }} }
			</h2>

			@if (isRegister === 2) {
				<p class="auth-form-panel__desc">{{ 'auth.resetPassword.description' | transloco }}</p>
			}
			@if (isRegister === 4) {
				<p class="auth-form-panel__desc">{{ 'auth.login.mfa.description' | transloco }}</p>
			}

			<ng-container *ngTemplateOutlet="formContent"></ng-container>
		} @else {
			<ng-container *ngTemplateOutlet="successState"></ng-container>
		}
	</div>
</ng-template>

<!-- DECORATIVE PANEL (desktop) -->
<ng-template #decorativePanel>
	<div class="auth-decorative-panel decorative-gradient">
		<span class="auth-decorative-panel__brand">{{ brandName }}</span>
		<h2 class="auth-decorative-panel__title">{{ decorativeContent.title }}</h2>
		<p class="auth-decorative-panel__text">{{ decorativeContent.text }}</p>
		<app-button
			class="decorative-cta-button"
			[label]="decorativeContent.cta"
			variant="secondary"
			size="medium"
			(onClick)="decorativeContent.ctaAction()">
		</app-button>
	</div>
</ng-template>

<!-- FORM CONTENT (shared between desktop panel and mobile) -->
<ng-template #formContent>
	@if (!showSuccessState) {

		@if (showSocialButtons) {
			<div class="auth-social-row">
				<app-button
					[label]="'auth.socialLogin.google' | transloco"
					variant="secondary"
					size="small"
					(onClick)="googleLogin.emit()">
				</app-button>
				<app-button
					[label]="'auth.socialLogin.apple' | transloco"
					icon="Smartphone"
					variant="secondary"
					size="small"
					(onClick)="appleLogin.emit()">
				</app-button>
			</div>
			<div class="auth-separator">
				<span>{{ 'auth.socialLogin.separator' | transloco }}</span>
			</div>
		}

		@if (isRegister !== 4) {
			<form
				[formGroup]="authForm"
				(ngSubmit)="onSubmit()"
				(keydown.enter)="submitOnEnterSafe($event)"
				(focusin)="onFormFocusIn()"
				class="auth-fields">

				@for (field of formFields; track field) {
					@if (field === 'email') {
						<app-input
							[placeholder]="'auth.placeholders.email' | transloco"
							size="medium"
							formControlName="email"
							[error]="submitted && !!authForm.get('email')?.invalid"
							[errorMessage]="getErrorMessage('email') || ''">
						</app-input>
					}

					@if ((isRegister !== 2) && field === 'password') {
						<app-input
							type="password"
							[showToggle]="false"
							[placeholder]="'auth.placeholders.password' | transloco"
							size="medium"
							formControlName="password"
							[error]="submitted && !!authForm.get('password')?.invalid"
							[errorMessage]="getErrorMessage('password') || ''">
						</app-input>
					}

					@if (field === 'newPassword') {
						<app-input
							type="password"
							[showToggle]="false"
							[placeholder]="'auth.changePassword.newPassword' | transloco"
							size="medium"
							formControlName="newPassword"
							[error]="submitted && !!authForm.get('newPassword')?.invalid"
							[errorMessage]="getErrorMessage('newPassword') || ''">
						</app-input>
					}

					@if (field === 'confirmPassword') {
						<app-input
							type="password"
							[showToggle]="false"
							[placeholder]="'auth.changePassword.confirmPassword' | transloco"
							size="medium"
							formControlName="confirmPassword"
							[error]="submitted && !!authForm.get('confirmPassword')?.invalid"
							[errorMessage]="getErrorMessage('confirmPassword') || ''">
						</app-input>
					}
				}

				<div class="auth-submit">
					<app-button
						[label]="isRegister === 1 ? ('auth.login.button' | transloco) :
								isRegister === 2 ? ('auth.resetPassword.button' | transloco) :
								isRegister === 5 ? ('auth.createAccount.button' | transloco) :
								('auth.changePassword.button' | transloco)"
						(click)="onSubmit()"
						size="medium"
						[loading]="loading">
					</app-button>
				</div>

				@if (isRegister === 1) {
					<div class="auth-forgot-link">
						<app-button
							[label]="'auth.login.forgotPassword' | transloco"
							variant="link"
							size="small"
							(onClick)="onForgotPasswordClick()">
						</app-button>
					</div>
					@if (loginExtra) {
						<ng-container *ngTemplateOutlet="loginExtra"></ng-container>
					}
				}
			</form>
		} @else {
			<form (ngSubmit)="onMfaSubmit()" (keydown.enter)="$event.preventDefault(); onMfaSubmit()" class="auth-fields">
				<div class="auth-mfa-boxes">
					@for (digit of mfaCode; track $index) {
						<div class="mfa-code-box">
							<input
								type="text"
								inputmode="numeric"
								pattern="[0-9]"
								maxlength="1"
								[id]="'mfa-' + $index"
								[value]="digit"
								(input)="onMfaInput($event, $index)"
								(keydown)="onMfaKeydown($event, $index)"
								(focus)="onMfaFocus($event)"
								autocomplete="off" />
						</div>
					}
				</div>

				@if (errorMessage) {
					<div class="auth-error-banner">{{ errorMessage }}</div>
				}

				<div class="auth-trust-device">
					<label>
						<input type="checkbox" [(ngModel)]="trustDevice" [ngModelOptions]="{standalone: true}" />
						{{ 'auth.login.mfa.trustDevice' | transloco }}
					</label>
				</div>

				<app-button
					[label]="'auth.login.mfa.verify' | transloco"
					(click)="onMfaSubmit()"
					size="medium"
					[loading]="loading">
				</app-button>
			</form>
		}

		@if (isRegister === 4) {
			<div class="auth-cancel-mfa">
				<app-button
					[label]="'common.actions.cancel' | transloco"
					variant="link"
					size="small"
					(onClick)="onCancelMFA()">
				</app-button>
			</div>
		}

	} @else {
		<ng-container *ngTemplateOutlet="successState"></ng-container>
	}
</ng-template>

<!-- SUCCESS STATE -->
<ng-template #successState>
	<div class="auth-success">
		<lucide-icon name="CircleCheck" class="auth-success__icon"></lucide-icon>
		<h2 class="auth-success__title">
			{{ 'auth.resetPasswordConfirm.success.title' | transloco }}
		</h2>
		<p class="auth-success__message">
			{{ 'auth.resetPasswordConfirm.success.message' | transloco }}
		</p>
		<app-button
			[label]="'auth.resetPasswordConfirm.success.button' | transloco"
			(onClick)="navigateToLogin()"
			size="medium">
		</app-button>
	</div>
</ng-template>
